import a1 from '../data/vocabulario_a1.json';
import a1b from '../data/vocabulario_a1b.json';
import a2 from '../data/vocabulario_a2.json';

export const VOCAB_TOPICS = [...a1, ...a1b, ...a2];

export const VOCAB_HUB = {
  path: '/recursos/vocabulario-espanol',
  seoTitle: 'Vocabulario de español A1 y A2 por temas | PDF gratis',
  seoDescription:
    'Aprende vocabulario de español A1 y A2 organizado por temas. Fichas con inglés y alemán sobre familia, viajes, profesiones, salud y mucho más.',
  h1: 'Vocabulario de español por temas',
};

export const topicPath = (slug) => `/recursos/vocabulario/${slug}`;
export const getTopic = (slug) => VOCAB_TOPICS.find((t) => t.slug === slug);
export const topicsByLevel = (level) => VOCAB_TOPICS.filter((t) => t.level === level);
